/*=========================================================================================
  File Name: mutations.js
  Namespace: sonar
  Description: Vuex Store - Sonar mutations
==========================================================================================*/
import { buildSonarState } from './state'

const mutations = {
  STORE_CURRENT_SONAR_ASSESSMENT(state, sonarAssessment) {
    state.currentSonar = { ...state.currentSonar, ...sonarAssessment }
  },
  RESET_CURRENT_SONAR(state) {
    state.currentSonar = buildSonarState()
  },
  STORE_LIST_SONAR(state, sonar) {
    state.sonarList = {
      ...state.sonarList,
      ...sonar.entries
    }
    state.count = sonar.count
    state.next = sonar.next
    state.previous = sonar.previous
    state.results = [...sonar.results]
  },
  SET_SONAR_STATUS(state, status) {
    state.currentSonar.SkillArea.areaStatus = status
  },
}

export default mutations